/**
 * Helpers for reading an activity's loosely-typed `payload`.
 *
 * The payload is JSON the backend stores per activity type, so it arrives as
 * `Record<string, unknown>` and every reader has to narrow it. Putting the
 * narrowing here keeps admin and student agreeing on the shape: both campaign
 * detail screens carried a byte-identical copy of `extractSkillRewards`,
 * including its doc comment.
 */

interface SkillReward {
  skillId: string;
  points: number;
}

/** Read the `skills: [{skillId, points}]` array off an activity's payload. */
export function extractSkillRewards(
  payload: Record<string, unknown> | null | undefined,
): SkillReward[] {
  const skills = (payload as { skills?: unknown } | null)?.skills;
  return Array.isArray(skills) ? (skills as SkillReward[]) : [];
}
